import { Icon } from 'semantic-ui-react'
import { connect } from 'react-redux';

import { AnalyticsActions, AnalyticsSelectors } from '../../modules/analytics';

var React = require('react');
var moment = require('moment');
var DateRangePicker = require('react-bootstrap-daterangepicker');


const { selectDate } = AnalyticsActions;
const { getSelectorFilters } = AnalyticsSelectors;


class DatePicker extends React.Component {

    constructor() {
        super()

        this.state = {
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(7, 'days'), moment().subtract(1, 'days')],
                'Last 30 Days': [moment().subtract(30, 'days'), moment().subtract(1, 'days')],
                'This Month': [moment().startOf('month'), moment(), moment()],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            startDate: moment().subtract(1, 'days'),
            endDate: moment().subtract(1, 'days'),
        }
        this.handleEvent = this.handleEvent.bind(this)
    }

    handleEvent(event, picker) {
        if (event.type === "hide") {
            if (picker.startDate.format('YYYY-MM-DD') === picker.oldStartDate.format('YYYY-MM-DD') && picker.endDate.format('YYYY-MM-DD') == picker.oldEndDate.format('YYYY-MM-DD'))
                return false;

            let starting_date = new Date(picker.startDate.format('YYYY-MM-DD'))
            let ending_date = new Date(picker.endDate.format('YYYY-MM-DD'))
            let difference = Math.abs(starting_date - ending_date)
            let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));

            let timeRangeValue = localStorage.getItem("TimeRange").toString()
            console.log("DATEEE RANGE------>", timeRangeValue)

            if (timeRangeValue == '1 MONTH') {
                if (TotalDays < 31) {
                    this.props.selectDate({
                        'start_date': picker.startDate.format('YYYY-MM-DD'),
                        'end_date': picker.endDate.format('YYYY-MM-DD')
                    });
                    console.log("DAYS----->", TotalDays)
                    this.setState({ 'startDate': picker.startDate });
                    this.setState({ 'endDate': picker.endDate });
                }else {
                    alert(`The applied date in the filter must be less than ${timeRangeValue} `)
                }
            } else if (timeRangeValue == '3 MONTHS') {
                if (TotalDays < 92) {
                    this.props.selectDate({
                        'start_date': picker.startDate.format('YYYY-MM-DD'),
                        'end_date': picker.endDate.format('YYYY-MM-DD')
                    });
                    console.log("DAYS----->", TotalDays)
                    this.setState({ 'startDate': picker.startDate });
                    this.setState({ 'endDate': picker.endDate });
                }else {
                    alert(`The applied date in the filter must be less than ${timeRangeValue} `)
                }
            } else if (timeRangeValue == '6 MONTHS') {
                if (TotalDays < 183) {
                    this.props.selectDate({
                        'start_date': picker.startDate.format('YYYY-MM-DD'),
                        'end_date': picker.endDate.format('YYYY-MM-DD')
                    });

                    console.log("DAYS----->", TotalDays)
                    this.setState({ 'startDate': picker.startDate });
                    this.setState({ 'endDate': picker.endDate });
                }else {
                    alert(`The applied date in the filter must be less than ${timeRangeValue} `)
                }
            }else{
                
                alert("You cannot apply date range. Please coordinate to the support team")
            }
            
        }
    }

    render() {
        let { selectedDate } = this.props;
        const start = selectedDate.start_date;
        const end = selectedDate.end_date;
        let label = start + ' - ' + end;
        if (start === end) {
            label = start;
        }
        return <DateRangePicker
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            ranges={this.state.ranges}
            onEvent={this.handleEvent}

        >
            <div>
                <span style={styles.dateMain}>
                    <span style={styles.label}>
                        Date: {label}
                    </span>
                    <img className='dateBg' style={styles.dateIcon} src="/date_icon.png" />

                </span>
            </div>
        </DateRangePicker>;
    }
}

const styles = {
    label: {
        paddingRight: 10,
        fontFamily: 'Helvetica',
        fontSize: 14,
    },
    dateMain: {
        position: 'relative',
        top: 24,
    },
    dateIcon: {
        backgroundColor: '#fff',
        position: 'relative',
        paddingRight: 7,
        paddingLeft: 7,
        paddingTop: 5,
        paddingBottom: 6,
        top: 12,
        borderRadius: 5,
    },
}

const mapStateToProps = state => {
    return getSelectorFilters(state);
}


export default connect(mapStateToProps, { selectDate })(DatePicker)



// WEBPACK FOOTER //
// ./src/components/DatePicker/index.js